import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatSliderModule } from '@angular/material/slider'
import { GooglePayButtonModule } from '@google-pay/button-angular';
// external modules
import { MomentModule } from 'ngx-moment';
// google maps
// import { AgmCoreModule } from '@agm/core';
// shared modules
import { SharedModule } from '../shared/shared.module';
// routing
import { FlybackBookingRoutingModule } from './flyback-booking-section.routing';
// containers
import { FlybackComponent } from './containers/flyback/flyback.component';
// components
import { GetFlybackDetailsComponent } from './components/get-flyback-details/get-flyback-details.component';
import { GetFlybackFlightResultsComponent } from './components/get-flyback-flight-results/get-flyback-flight-results.component';
import { FlybackFlightConfirmationComponent } from './components/flyback-flight-confirmation/flyback-flight-confirmation.component';
import { FlybackFlightResultsComponent } from './components/flyback-flight-results/flyback-flight-results.component';
// datepicker
import { MatDatepickerModule } from '@angular/material/datepicker';

export function importItems() {
  return [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MomentModule,
    // AgmCoreModule,
    GooglePayButtonModule,
    NgSelectModule,
    MatSliderModule,
    FlybackBookingRoutingModule,
    MatDatepickerModule
  ];
}

export function declarationItems() {
  return [
    FlybackComponent,
    GetFlybackDetailsComponent,
    GetFlybackFlightResultsComponent,
    FlybackFlightResultsComponent,
    FlybackFlightConfirmationComponent
  ];
}

@NgModule({
  imports: importItems(),
  declarations: declarationItems(),
  exports: [
    FlybackComponent
  ]
})
export class FlybackBookingSectionModule { }
